import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EventApi from "../api/EventApi";

export const Reports = ({ eventID }) => {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [restricted, setRestricted] = useState(false);

  const onSelectReport = (index) => {
    const report = reports[index];
    setSelectedReport(report);
  };

  const openUser = (userID) => {
    if (!userID) return;
    navigate(`/users?q=${encodeURIComponent(userID)}`);
  };

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const { reports: reportsData, restricted: noCaseAccess } = await EventApi.fetchReportsByEventID(eventID);
        setReports(reportsData);
        setRestricted(noCaseAccess);
      } catch (error) {
        console.error("Error fetching reports:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  if (loading) {
    return <div>Loading reports...</div>;
  }

  const restrictedNote = restricted ? (
    <p className="p-4 text-sm text-gray-500 dark:text-gray-400">
      Reports are kept as arbitration cases. Your account needs the superAdmin claim to see them.
    </p>
  ) : null;

  if (reports.length === 0) {
    return restrictedNote || <div>No reports found.</div>;
  }

  return (
    <>
      {restrictedNote}
      <div className="flex">
        <div className="w-1/3 p-4">
          <ul>
            {reports.map((report, index) => (
              <li key={index} className="mb-2">
                <button
                  className="text-blue-500 dark:text-blue-400 hover:underline text-left"
                  onClick={() => onSelectReport(index)}
                >
                  {report.reportedByName}
                  <span className="text-gray-500 dark:text-gray-400"> → </span>
                  {report.reportedName}
                </button>
              </li>
            ))}
          </ul>
        </div>
        {selectedReport && (
          <div className="w-2/3 p-4 border-l dark:border-gray-700">
            <div className="space-y-3">
              <div>
                <p className="font-semibold">Reported person</p>
                <p>
                  {selectedReport.reportedName}{" "}
                  {selectedReport.reportedUserID && (
                    <button
                      className="text-blue-500 dark:text-blue-400 hover:underline text-sm font-mono"
                      onClick={() => openUser(selectedReport.reportedUserID)}
                      title="Open in Users"
                    >
                      {selectedReport.reportedUserID}
                    </button>
                  )}
                </p>
              </div>
              <div>
                <p className="font-semibold">Reported by</p>
                <p>
                  {selectedReport.reportedByName}{" "}
                  {selectedReport.reportedByUserID && (
                    <button
                      className="text-blue-500 dark:text-blue-400 hover:underline text-sm font-mono"
                      onClick={() => openUser(selectedReport.reportedByUserID)}
                      title="Open in Users"
                    >
                      {selectedReport.reportedByUserID}
                    </button>
                  )}
                </p>
              </div>
              <div>
                <p className="font-semibold">Reason</p>
                <p>{selectedReport.note}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
